import { APIRequestBodyModel } from '@app/models/server/layout.model';

export abstract class DownloadFile {
  abstract downloadFile(
    apiUrl: string,
    body: APIRequestBodyModel,
    bookingPagePath: string,
  );
}
